/* eslint-disable complexity */
/* eslint-disable react/function-component-definition */

// card v3
import { Box, Button, CircularProgress, Dialog } from '@mui/material';
import PackagePrintApi from 'api/productDetail/useGetPrintProductPackaging/useGetPrintProductPackaging';
import PrintLogo from 'assets/images/printPackageLogo/print-logo.png';
import PrintLogo2 from 'assets/images/printPackageLogo/print-logo2.png';
import React, { useEffect, useRef, useState } from 'react';
import { Textfit } from 'react-textfit';
import { useReactToPrint } from 'react-to-print';

export default function PackagePrintModal({ guid, open, setOpen }) {
  const printElRef = useRef(null);
  const [getData, loading, data] = PackagePrintApi(guid);

  useEffect(() => {
    if (guid && open) {
      getData();
    }
  }, [guid, open]);

  const reactToPrintFn = useReactToPrint({
    contentRef: printElRef,
  });

  return (
    <Dialog maxWidth="sm" fullWidth onClose={() => setOpen(false)} open={open}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '16px',
        }}
        dir="rtl"
      >
        {loading ? (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '220px',
            }}
          >
            <CircularProgress />
          </Box>
        ) : null}

        {/* dev, zebra, saharkhiz (large) */}
        {data &&
        !loading &&
        (data.type === '1' || data.type === '9' || data.type === '11') ? (
          <Box
            ref={printElRef}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '2mm',
              marginLeft: '0',
              paddingTop: '0',
            }}
          >
            <Box
              sx={{
                color: 'black',
                fontSize: '0.8rem',
                fontWeight: '700',
                display: 'flex',
                alignItems: 'center',
                maxWidth: '75mm',
                maxHeight: '40mm',
                minWidth: '75mm',
                minHeight: '40mm',
                direction: 'ltr',
                border: '1px solid #ccc',
                paddingX: '6px',
                paddingTop: '5mm',
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  height: '35mm',
                  paddingTop: '6mm',
                  paddingBottom: '0mm',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    justifyContent: 'flex-end',
                    height: '100%',
                    gap: '0.2rem',
                  }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      height: '20mm',
                      maxHeight: '20mm',
                      display: 'flex',
                      flexDirection: 'row-reverse',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      gap: '0.2rem',
                      paddingTop: '14px',
                    }}
                  >
                    <Box
                      as="img"
                      src={data.qr}
                      sx={{
                        alignSelft: 'start',
                        height: '18mm',
                        width: '18mm',
                      }}
                    />
                    <Box
                      sx={{
                        width: 'calc(100% - 27mm)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        gap: '0.1rem',
                      }}
                    >
                      {data.showPacking ? (
                        <Box
                          sx={{
                            width: '100%',
                            textAlign: 'center',
                            direction: 'rtl',
                            fontSize: '2.5mm',
                          }}
                        >
                          {data.package}
                        </Box>
                      ) : null}
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignSelf: 'start',
                      justifyContent: 'space-around',
                      // paddingTop: '0.6rem',
                      // minHeight: data.type === '0' ? '25mm' : '32.64mm',
                      flexGrow: '1',
                    }}
                  >
                    <div>
                      <Box
                        sx={{
                          width: '99%',
                          height: '9mm',
                          textAlign: 'center',
                          direction: 'rtl',
                          fontSize: '3mm',
                        }}
                      >
                        <Textfit
                          mode="multi"
                          min={10}
                          max={14}
                          style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          {data.name}
                        </Textfit>
                      </Box>
                    </div>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                      }}
                    >
                      <Box
                        sx={{
                          textAlign: 'left',
                          direction: 'rtl',
                          fontSize: '10px',
                        }}
                      >
                        {data.code1}
                      </Box>
                      <Box
                        sx={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <Box
                          sx={{
                            textAlign: 'left',
                            direction: 'rtl',
                            fontSize: '10px',
                          }}
                        >
                          {data.code2}
                        </Box>
                        {data.showDate ? (
                          <Box
                            sx={{
                              textAlign: 'left',
                              direction: 'rtl',
                              fontSize: '10px',
                            }}
                          >
                            {data.date}
                          </Box>
                        ) : (
                          <div />
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        ) : null}

        {/* dev, zebra, saharkhiz (sm) */}
        {data &&
        !loading &&
        (data.type === '2' || data.type === '10' || data.type === '12') ? (
          <Box
            ref={printElRef}
            sx={{
              // display: 'flex',
              // flexDirection: 'row',
              // justifyContent: 'space-between',
              // alignItems: 'center',
              // gap: '5mm',
              // marginLeft: '4mm',
              display: 'grid',
              gridTemplateColumns: '50mm 50mm',
              columnGap: '3mm',
              // paddingTop: '2mm',
            }}
          >
            <Box
              sx={{
                color: 'black',
                fontSize: '0.8rem',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                maxWidth: '50mm',
                maxHeight: '35mm',
                minWidth: '50mm',
                minHeight: '35mm',
                direction: 'ltr',
                border: '1px solid #ccc',
                paddingX: '6px',
                // paddingTop: '2mm',
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  height: '35mm',
                  paddingTop: '5mm',
                  paddingBottom: '1mm',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    justifyContent: 'flex-end',
                    height: '100%',
                    gap: '0.2rem',
                  }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      height: '17mm',
                      maxHeight: '17mm',
                      display: 'flex',
                      flexDirection: 'row-reverse',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      gap: '0.2rem',
                      paddingTop: '14px',
                    }}
                  >
                    <Box
                      as="img"
                      src={data.qr}
                      sx={{
                        alignSelft: 'start',
                        height: '16mm',
                        width: '16mm',
                      }}
                    />
                    <Box
                      sx={{
                        width: 'calc(100% - 21.5mm)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        gap: '0.1rem',
                      }}
                    >
                      {data.showPacking ? (
                        <Box
                          sx={{
                            width: '100%',
                            textAlign: 'center',
                            direction: 'rtl',
                            fontSize: '2.5mm',
                          }}
                        >
                          {data.package}
                        </Box>
                      ) : null}
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignSelf: 'start',
                      justifyContent: 'space-around',
                      // paddingTop: '0.6rem',
                      // minHeight: data.type === '0' ? '25mm' : '32.64mm',
                      flexGrow: '1',
                    }}
                  >
                    <div>
                      <Box
                        sx={{
                          width: '99%',
                          height: '9mm',
                          textAlign: 'center',
                          direction: 'rtl',
                          fontSize: '3mm',
                        }}
                      >
                        <Textfit
                          mode="multi"
                          min={7}
                          max={14}
                          style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          {data.name}
                        </Textfit>
                      </Box>
                    </div>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        marginTop: '-2px',
                      }}
                    >
                      <Box
                        sx={{
                          textAlign: 'left',
                          direction: 'rtl',
                          fontSize: '9px',
                        }}
                      >
                        {data.code1}
                      </Box>
                      <Box
                        sx={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          paddingRight: '5px',
                        }}
                      >
                        <Box
                          sx={{
                            textAlign: 'left',
                            direction: 'rtl',
                            fontSize: '9px',
                          }}
                        >
                          {data.code2}
                        </Box>
                        {data.showDate ? (
                          <Box
                            sx={{
                              textAlign: 'left',
                              direction: 'rtl',
                              fontSize: '8px',
                            }}
                          >
                            {data.date}
                          </Box>
                        ) : (
                          <div />
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            {/* <Box
            sx={{
              '@media print': {
                pageBreakAfter: 'always',
                breakAfter: 'page',
              },
            }}
          /> */}
            <Box
              // ref={printElRef}
              sx={{
                color: 'black',
                fontSize: '0.8rem',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                maxWidth: '50mm',
                maxHeight: '35mm',
                minWidth: '50mm',
                minHeight: '35mm',
                direction: 'ltr',
                border: '1px solid #ccc',
                paddingX: '6px',
                // paddingTop: '2mm',
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  height: '35mm',
                  paddingTop: '5mm',
                  paddingBottom: '1mm',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    justifyContent: 'flex-end',
                    height: '100%',
                    gap: '0.2rem',
                  }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      height: '17mm',
                      maxHeight: '17mm',
                      display: 'flex',
                      flexDirection: 'row-reverse',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      gap: '0.2rem',
                      paddingTop: '14px',
                    }}
                  >
                    <Box
                      as="img"
                      src={data.qr}
                      sx={{
                        alignSelft: 'start',
                        height: '16mm',
                        width: '16mm',
                      }}
                    />
                    <Box
                      sx={{
                        width: 'calc(100% - 21.5mm)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        gap: '0.1rem',
                      }}
                    >
                      {data.showPacking ? (
                        <Box
                          sx={{
                            width: '100%',
                            textAlign: 'center',
                            direction: 'rtl',
                            fontSize: '2.5mm',
                          }}
                        >
                          {data.package}
                        </Box>
                      ) : null}
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignSelf: 'start',
                      justifyContent: 'space-around',
                      // paddingTop: '0.6rem',
                      // minHeight: data.type === '0' ? '25mm' : '32.64mm',
                      flexGrow: '1',
                    }}
                  >
                    <div>
                      <Box
                        sx={{
                          width: '99%',
                          height: '9mm',
                          textAlign: 'center',
                          direction: 'rtl',
                          fontSize: '3mm',
                        }}
                      >
                        <Textfit
                          mode="multi"
                          min={7}
                          max={14}
                          style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          {data.name}
                        </Textfit>
                      </Box>
                    </div>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        marginTop: '-2px',
                      }}
                    >
                      <Box
                        sx={{
                          textAlign: 'left',
                          direction: 'rtl',
                          fontSize: '9px',
                        }}
                      >
                        {data.code1}
                      </Box>
                      <Box
                        sx={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          paddingRight: '5px',
                        }}
                      >
                        <Box
                          sx={{
                            textAlign: 'left',
                            direction: 'rtl',
                            fontSize: '9px',
                          }}
                        >
                          {data.code2}
                        </Box>
                        {data.showDate ? (
                          <Box
                            sx={{
                              textAlign: 'left',
                              direction: 'rtl',
                              fontSize: '8px',
                            }}
                          >
                            {data.date}
                          </Box>
                        ) : (
                          <div />
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        ) : null}

        {/* AKK (large) */}
        {data && !loading && data.type === '3' ? (
          <Box
            ref={printElRef}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '2mm',
              marginLeft: '0',
              paddingTop: '0',
            }}
          >
            <Box
              sx={{
                color: 'black',
                fontSize: '0.8rem',
                fontWeight: '700',
                display: 'flex',
                alignItems: 'center',
                maxWidth: '75mm',
                maxHeight: '40mm',
                minWidth: '75mm',
                minHeight: '40mm',
                direction: 'ltr',
                border: '1px solid #ccc',
                paddingX: '6px',
                paddingTop: '5mm',
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  height: '35mm',
                  paddingTop: '6mm',
                  paddingBottom: '0mm',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    justifyContent: 'flex-end',
                    height: '100%',
                    gap: '0.2rem',
                  }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      height: '20mm',
                      maxHeight: '20mm',
                      display: 'flex',
                      flexDirection: 'row-reverse',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      gap: '0.2rem',
                      paddingTop: '14px',
                    }}
                  >
                    <Box
                      as="img"
                      src={data.qr}
                      sx={{
                        alignSelft: 'start',
                        height: '18mm',
                        width: '18mm',
                      }}
                    />
                    <Box
                      sx={{
                        width: 'calc(100% - 27mm)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        gap: '0.1rem',
                      }}
                    >
                      {data.showPacking ? (
                        <Box
                          sx={{
                            width: '100%',
                            textAlign: 'center',
                            direction: 'rtl',
                            fontSize: '2.5mm',
                          }}
                        >
                          {data.package}
                        </Box>
                      ) : null}
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignSelf: 'start',
                      justifyContent: 'space-around',
                      // paddingTop: '0.6rem',
                      // minHeight: data.type === '0' ? '25mm' : '32.64mm',
                      flexGrow: '1',
                    }}
                  >
                    <div>
                      <Box
                        sx={{
                          width: '99%',
                          height: '9mm',
                          textAlign: 'center',
                          direction: 'rtl',
                          fontSize: '3mm',
                        }}
                      >
                        <Textfit
                          mode="multi"
                          min={10}
                          max={14}
                          style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          {data.name}
                        </Textfit>
                      </Box>
                    </div>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                      }}
                    >
                      <Box
                        sx={{
                          textAlign: 'left',
                          direction: 'rtl',
                          fontSize: '10px',
                        }}
                      >
                        {data.code1}
                      </Box>
                      <Box
                        sx={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <Box
                          sx={{
                            textAlign: 'left',
                            direction: 'rtl',
                            fontSize: '10px',
                          }}
                        >
                          {data.code2}
                        </Box>
                        {data.showDate ? (
                          <Box
                            sx={{
                              textAlign: 'left',
                              direction: 'rtl',
                              fontSize: '10px',
                            }}
                          >
                            {data.date}
                          </Box>
                        ) : (
                          <div />
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        ) : null}

        {/* AKK (sm) */}
        {data && !loading && data.type === '4' ? (
          <Box
            ref={printElRef}
            sx={{
              // display: 'flex',
              // flexDirection: 'row',
              // justifyContent: 'space-between',
              // alignItems: 'center',
              // gap: '5mm',
              // marginLeft: '4mm',
              display: 'grid',
              gridTemplateColumns: '50mm 50mm',
              columnGap: '3mm',
              // paddingTop: '2mm',
            }}
          >
            <Box
              sx={{
                color: 'black',
                fontSize: '0.8rem',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                maxWidth: '50mm',
                maxHeight: '35mm',
                minWidth: '50mm',
                minHeight: '35mm',
                direction: 'ltr',
                border: '1px solid #ccc',
                paddingX: '6px',
                // paddingTop: '2mm',
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  height: '35mm',
                  paddingTop: '5mm',
                  paddingBottom: '1mm',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    justifyContent: 'flex-end',
                    height: '100%',
                    gap: '0.2rem',
                  }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      height: '17mm',
                      maxHeight: '17mm',
                      display: 'flex',
                      flexDirection: 'row-reverse',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      gap: '0.2rem',
                      paddingTop: '14px',
                    }}
                  >
                    <Box
                      as="img"
                      src={data.qr}
                      sx={{
                        alignSelft: 'start',
                        height: '16mm',
                        width: '16mm',
                      }}
                    />
                    <Box
                      sx={{
                        width: 'calc(100% - 21.5mm)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        gap: '0.1rem',
                      }}
                    >
                      {data.showPacking ? (
                        <Box
                          sx={{
                            width: '100%',
                            textAlign: 'center',
                            direction: 'rtl',
                            fontSize: '2.5mm',
                          }}
                        >
                          {data.package}
                        </Box>
                      ) : null}
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignSelf: 'start',
                      justifyContent: 'space-around',
                      // paddingTop: '0.6rem',
                      // minHeight: data.type === '0' ? '25mm' : '32.64mm',
                      flexGrow: '1',
                    }}
                  >
                    <div>
                      <Box
                        sx={{
                          width: '99%',
                          height: '9mm',
                          textAlign: 'center',
                          direction: 'rtl',
                          fontSize: '3mm',
                        }}
                      >
                        <Textfit
                          mode="multi"
                          min={7}
                          max={14}
                          style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          {data.name}
                        </Textfit>
                      </Box>
                    </div>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        marginTop: '-2px',
                      }}
                    >
                      <Box
                        sx={{
                          textAlign: 'left',
                          direction: 'rtl',
                          fontSize: '9px',
                        }}
                      >
                        {data.code1}
                      </Box>
                      <Box
                        sx={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          paddingRight: '5px',
                        }}
                      >
                        <Box
                          sx={{
                            textAlign: 'left',
                            direction: 'rtl',
                            fontSize: '9px',
                          }}
                        >
                          {data.code2}
                        </Box>
                        {data.showDate ? (
                          <Box
                            sx={{
                              textAlign: 'left',
                              direction: 'rtl',
                              fontSize: '8px',
                            }}
                          >
                            {data.date}
                          </Box>
                        ) : (
                          <div />
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            {/* <Box
            sx={{
              '@media print': {
                pageBreakAfter: 'always',
                breakAfter: 'page',
              },
            }}
          /> */}
            <Box
              // ref={printElRef}
              sx={{
                color: 'black',
                fontSize: '0.8rem',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                maxWidth: '50mm',
                maxHeight: '35mm',
                minWidth: '50mm',
                minHeight: '35mm',
                direction: 'ltr',
                border: '1px solid #ccc',
                paddingX: '6px',
                // paddingTop: '2mm',
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  height: '35mm',
                  paddingTop: '5mm',
                  paddingBottom: '1mm',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    justifyContent: 'flex-end',
                    height: '100%',
                    gap: '0.2rem',
                  }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      height: '17mm',
                      maxHeight: '17mm',
                      display: 'flex',
                      flexDirection: 'row-reverse',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      gap: '0.2rem',
                      paddingTop: '14px',
                    }}
                  >
                    <Box
                      as="img"
                      src={data.qr}
                      sx={{
                        alignSelft: 'start',
                        height: '16mm',
                        width: '16mm',
                      }}
                    />
                    <Box
                      sx={{
                        width: 'calc(100% - 21.5mm)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        gap: '0.1rem',
                      }}
                    >
                      {data.showPacking ? (
                        <Box
                          sx={{
                            width: '100%',
                            textAlign: 'center',
                            direction: 'rtl',
                            fontSize: '2.5mm',
                          }}
                        >
                          {data.package}
                        </Box>
                      ) : null}
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignSelf: 'start',
                      justifyContent: 'space-around',
                      // paddingTop: '0.6rem',
                      // minHeight: data.type === '0' ? '25mm' : '32.64mm',
                      flexGrow: '1',
                    }}
                  >
                    <div>
                      <Box
                        sx={{
                          width: '99%',
                          height: '9mm',
                          textAlign: 'center',
                          direction: 'rtl',
                          fontSize: '3mm',
                        }}
                      >
                        <Textfit
                          mode="multi"
                          min={7}
                          max={14}
                          style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          {data.name}
                        </Textfit>
                      </Box>
                    </div>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        marginTop: '-2px',
                      }}
                    >
                      <Box
                        sx={{
                          textAlign: 'left',
                          direction: 'rtl',
                          fontSize: '9px',
                        }}
                      >
                        {data.code1}
                      </Box>
                      <Box
                        sx={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          paddingRight: '5px',
                        }}
                      >
                        <Box
                          sx={{
                            textAlign: 'left',
                            direction: 'rtl',
                            fontSize: '9px',
                          }}
                        >
                          {data.code2}
                        </Box>
                        {data.showDate ? (
                          <Box
                            sx={{
                              textAlign: 'left',
                              direction: 'rtl',
                              fontSize: '8px',
                            }}
                          >
                            {data.date}
                          </Box>
                        ) : (
                          <div />
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        ) : null}

        {/* AKK (xsm) */}
        {data && !loading && data.type === '5' ? (
          <Box
            ref={printElRef}
            sx={{
              // display: 'flex',
              // flexDirection: 'row',
              // justifyContent: 'space-between',
              // alignItems: 'center',
              // gap: '5mm',
              // marginLeft: '4mm',
              display: 'grid',
              gridTemplateColumns: '45mm 45mm',
              columnGap: '3mm',
              // paddingTop: '2mm',
            }}
          >
            <Box
              sx={{
                position: 'relative',
                color: 'black',
                fontSize: '0.8rem',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                maxWidth: '45mm',
                maxHeight: '30mm',
                minWidth: '45mm',
                minHeight: '30mm',
                direction: 'ltr',
                border: '1px solid #ccc',
                paddingX: '6px',
                // paddingTop: '2mm',
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: '2px',
                  left: '35%',
                  transform: 'translateX(-50%)',
                }}
              >
                <img src={PrintLogo} width={35} />
              </Box>
              <Box
                sx={{
                  width: '100%',
                  height: '30mm',
                  paddingTop: '5mm',
                  paddingBottom: '1mm',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    justifyContent: 'flex-end',
                    height: '100%',
                    gap: '0.1rem',
                  }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      height: '17mm',
                      maxHeight: '17mm',
                      display: 'flex',
                      flexDirection: 'row-reverse',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      gap: '0.2rem',
                      paddingTop: '14px',
                    }}
                  >
                    {/* <Box
                      sx={{
                        position: 'absolute',
                        top: '8px',
                        left: '0',
                      }}
                    >
                      <img src={PrintLogo} width={45} />
                    </Box> */}
                    {/* <Box
                      sx={{
                        position: 'absolute',
                        top: '1px',
                        left: '35%',
                        transform: 'translateX(-50%)',
                      }}
                    >
                      <Box
                        sx={{
                          fontSize: '17px',
                        }}
                      >
                        AKK
                      </Box>
                    </Box> */}
                    <Box
                      as="img"
                      src={data.qr}
                      sx={{
                        alignSelft: 'start',
                        height: '14mm',
                        width: '14mm',
                      }}
                    />
                    <Box
                      sx={{
                        width: 'calc(100% - 14.5mm)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        gap: '0.1rem',
                        marginTop: '7mm',
                      }}
                    >
                      {data.showPacking ? (
                        <Box
                          sx={{
                            width: '100%',
                            height: '9mm',
                            textAlign: 'center',
                            direction: 'rtl',
                            fontSize: '2.5mm',
                          }}
                        >
                          <Textfit
                            mode="multi"
                            min={7}
                            max={14}
                            style={{
                              width: '100%',
                              height: '100%',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            {data.package}
                          </Textfit>
                        </Box>
                      ) : null}
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignSelf: 'start',
                      justifyContent: 'space-around',
                      // paddingTop: '0.6rem',
                      // minHeight: data.type === '0' ? '25mm' : '32.64mm',
                      flexGrow: '1',
                    }}
                  >
                    <div>
                      <Box
                        sx={{
                          width: '99%',
                          height: '9mm',
                          textAlign: 'center',
                          direction: 'rtl',
                          fontSize: '2.5mm',
                        }}
                      >
                        <Textfit
                          mode="multi"
                          min={7}
                          max={12}
                          style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          {data.name}
                        </Textfit>
                      </Box>
                    </div>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        marginTop: '-2px',
                      }}
                    >
                      <Box
                        sx={{
                          textAlign: 'left',
                          direction: 'rtl',
                          fontSize: '8px',
                        }}
                      >
                        {data.code1}
                      </Box>
                      <Box
                        sx={{
                          width: '100%',
                          minHeight: '8px',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          paddingRight: '5px',
                          marginTop: data.code1 ? '-4px' : '0',
                          marginBottom: '4px',
                        }}
                      >
                        <Box
                          sx={{
                            textAlign: 'left',
                            direction: 'rtl',
                            fontSize: '9px',
                          }}
                        >
                          {data.code2}
                        </Box>
                        {data.showDate ? (
                          <Box
                            sx={{
                              textAlign: 'left',
                              direction: 'rtl',
                              fontSize: '8px',
                            }}
                          >
                            {data.date}
                          </Box>
                        ) : (
                          <div />
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            {/* <Box
            sx={{
              '@media print': {
                pageBreakAfter: 'always',
                breakAfter: 'page',
              },
            }}
          /> */}
            <Box
              // ref={printElRef}
              sx={{
                position: 'relative',
                color: 'black',
                fontSize: '0.8rem',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                maxWidth: '45mm',
                maxHeight: '30mm',
                minWidth: '45mm',
                minHeight: '30mm',
                direction: 'ltr',
                border: '1px solid #ccc',
                paddingX: '6px',
                // paddingTop: '2mm',
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: '2px',
                  left: '35%',
                  transform: 'translateX(-50%)',
                }}
              >
                <img src={PrintLogo} width={35} />
              </Box>
              <Box
                sx={{
                  width: '100%',
                  height: '30mm',
                  paddingTop: '5mm',
                  paddingBottom: '1mm',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    justifyContent: 'flex-end',
                    height: '100%',
                    gap: '0.1rem',
                  }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      height: '17mm',
                      maxHeight: '17mm',
                      display: 'flex',
                      flexDirection: 'row-reverse',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      gap: '0.2rem',
                      paddingTop: '14px',
                    }}
                  >
                    {/* <Box
                      sx={{
                        position: 'absolute',
                        top: '8px',
                        left: '0',
                      }}
                    >
                      <img src={PrintLogo} width={45} />
                    </Box> */}
                    {/* <Box
                      sx={{
                        position: 'absolute',
                        top: '1px',
                        left: '35%',
                        transform: 'translateX(-50%)',
                      }}
                    >
                      <Box
                        sx={{
                          fontSize: '17px',
                        }}
                      >
                        AKK
                      </Box>
                    </Box> */}
                    <Box
                      as="img"
                      src={data.qr}
                      sx={{
                        alignSelft: 'start',
                        height: '14mm',
                        width: '14mm',
                      }}
                    />
                    <Box
                      sx={{
                        width: 'calc(100% - 14.5mm)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        gap: '0.1rem',
                        marginTop: '7mm',
                      }}
                    >
                      {data.showPacking ? (
                        <Box
                          sx={{
                            width: '100%',
                            height: '9mm',
                            textAlign: 'center',
                            direction: 'rtl',
                            fontSize: '2.5mm',
                          }}
                        >
                          <Textfit
                            mode="multi"
                            min={7}
                            max={14}
                            style={{
                              width: '100%',
                              height: '100%',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            {data.package}
                          </Textfit>
                        </Box>
                      ) : null}
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignSelf: 'start',
                      justifyContent: 'space-around',
                      // paddingTop: '0.6rem',
                      // minHeight: data.type === '0' ? '25mm' : '32.64mm',
                      flexGrow: '1',
                    }}
                  >
                    <div>
                      <Box
                        sx={{
                          width: '99%',
                          height: '9mm',
                          textAlign: 'center',
                          direction: 'rtl',
                          fontSize: '2.5mm',
                        }}
                      >
                        <Textfit
                          mode="multi"
                          min={7}
                          max={12}
                          style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          {data.name}
                        </Textfit>
                      </Box>
                    </div>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        marginTop: '-2px',
                      }}
                    >
                      <Box
                        sx={{
                          textAlign: 'left',
                          direction: 'rtl',
                          fontSize: '8px',
                        }}
                      >
                        {data.code1}
                      </Box>
                      <Box
                        sx={{
                          minHeight: '8px',
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          paddingRight: '5px',
                          marginTop: data.code1 ? '-4px' : '0',
                          marginBottom: '4px',
                        }}
                      >
                        <Box
                          sx={{
                            textAlign: 'left',
                            direction: 'rtl',
                            fontSize: '9px',
                          }}
                        >
                          {data.code2}
                        </Box>
                        {data.showDate ? (
                          <Box
                            sx={{
                              textAlign: 'left',
                              direction: 'rtl',
                              fontSize: '8px',
                            }}
                          >
                            {data.date}
                          </Box>
                        ) : (
                          <div />
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        ) : null}

        {/* atrass (large) */}
        {data && !loading && data.type === '6' ? (
          <Box
            ref={printElRef}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '2mm',
              marginLeft: '0',
              paddingTop: '0',
            }}
          >
            <Box
              sx={{
                color: 'black',
                fontSize: '0.8rem',
                fontWeight: '700',
                display: 'flex',
                alignItems: 'center',
                maxWidth: '75mm',
                maxHeight: '40mm',
                minWidth: '75mm',
                minHeight: '40mm',
                direction: 'ltr',
                border: '1px solid #ccc',
                paddingX: '6px',
                paddingTop: '5mm',
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  height: '35mm',
                  paddingTop: '6mm',
                  paddingBottom: '0mm',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    justifyContent: 'flex-end',
                    height: '100%',
                    gap: '0.2rem',
                  }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      height: '20mm',
                      maxHeight: '20mm',
                      display: 'flex',
                      flexDirection: 'row-reverse',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      gap: '0.2rem',
                      paddingTop: '14px',
                    }}
                  >
                    <Box
                      as="img"
                      src={data.qr}
                      sx={{
                        alignSelft: 'start',
                        height: '18mm',
                        width: '18mm',
                      }}
                    />
                    <Box
                      sx={{
                        width: 'calc(100% - 27mm)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        gap: '0.1rem',
                      }}
                    >
                      {data.showPacking ? (
                        <Box
                          sx={{
                            width: '100%',
                            textAlign: 'center',
                            direction: 'rtl',
                            fontSize: '2.5mm',
                          }}
                        >
                          {data.package}
                        </Box>
                      ) : null}
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignSelf: 'start',
                      justifyContent: 'space-around',
                      // paddingTop: '0.6rem',
                      // minHeight: data.type === '0' ? '25mm' : '32.64mm',
                      flexGrow: '1',
                    }}
                  >
                    <div>
                      <Box
                        sx={{
                          width: '99%',
                          height: '9mm',
                          textAlign: 'center',
                          direction: 'rtl',
                          fontSize: '3mm',
                        }}
                      >
                        <Textfit
                          mode="multi"
                          min={10}
                          max={14}
                          style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          {data.name}
                        </Textfit>
                      </Box>
                    </div>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                      }}
                    >
                      <Box
                        sx={{
                          textAlign: 'left',
                          direction: 'rtl',
                          fontSize: '10px',
                        }}
                      >
                        {data.code1}
                      </Box>
                      <Box
                        sx={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <Box
                          sx={{
                            textAlign: 'left',
                            direction: 'rtl',
                            fontSize: '10px',
                          }}
                        >
                          {data.code2}
                        </Box>
                        {data.showDate ? (
                          <Box
                            sx={{
                              textAlign: 'left',
                              direction: 'rtl',
                              fontSize: '10px',
                            }}
                          >
                            {data.date}
                          </Box>
                        ) : (
                          <div />
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        ) : null}

        {/* atrass (sm) atrass and megamad logo */}
        {data && !loading && (data.type === '7' || data.type === '8') ? (
          <Box
            ref={printElRef}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '3mm',
              // marginLeft: '4mm',
              marginRight: '6mm',
              // paddingTop: '2mm',
            }}
          >
            <Box
              // ref={printElRef}
              sx={{
                position: 'relative',
                color: 'black',
                fontSize: '0.8rem',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                maxWidth: '50mm',
                maxHeight: '35mm',
                minWidth: '50mm',
                minHeight: '35mm',
                direction: 'ltr',
                border: '1px solid #ccc',
                paddingX: '6px',
                // paddingTop: '2mm',
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: '8px',
                  left: '0',
                }}
              >
                <img
                  src={data.type === '8' ? PrintLogo2 : PrintLogo}
                  width={75}
                  alt=""
                />
              </Box>
              <Box
                sx={{
                  width: '100%',
                  height: '35mm',
                  // paddingTop: '5mm',
                  // paddingBottom: '1mm',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    justifyContent: 'flex-end',
                    height: '100%',
                    gap: '0.2rem',
                  }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      height: '17mm',
                      maxHeight: '17mm',
                      display: 'flex',
                      flexDirection: 'row-reverse',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      gap: '0.2rem',
                      paddingTop: '14px',
                    }}
                  >
                    <Box
                      as="img"
                      src={data.qr}
                      sx={{
                        alignSelft: 'start',
                        height: '16mm',
                        width: '16mm',
                      }}
                    />
                    <Box
                      sx={{
                        width: 'calc(100% - 17.5mm)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        paddingTop: '24px',
                      }}
                    >
                      <Box
                        sx={{
                          width: '100%',
                          display: 'flex',
                          flexDirection: 'column-reverse',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <Box
                          sx={{
                            width: '100%',
                            textAlign: 'left',
                            direction: 'rtl',
                            fontSize: '12px',
                          }}
                        >
                          {data.code2}
                        </Box>
                        <Box
                          sx={{
                            width: '100%',
                            textAlign: 'right',
                            direction: 'rtl',
                            fontSize: '9px',
                          }}
                        >
                          کد فنی:
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignSelf: 'start',
                      justifyContent: 'space-around',
                      // paddingTop: '0.6rem',
                      // minHeight: data.type === '0' ? '25mm' : '32.64mm',
                      flexGrow: '1',
                    }}
                  >
                    <div>
                      <Box
                        sx={{
                          height: '9mm',
                          textAlign: 'center',
                          direction: 'rtl',
                          fontSize: '3mm',
                        }}
                      >
                        <Textfit
                          mode="multi"
                          min={7}
                          max={14}
                          style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            fontWeight: 'bold',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          {data.name}
                        </Textfit>
                      </Box>
                    </div>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        marginTop: '-2px',
                      }}
                    >
                      <Box
                        sx={{
                          textAlign: 'left',
                          direction: 'rtl',
                          fontSize: '9px',
                        }}
                      >
                        {data.code1}
                      </Box>

                      <Box
                        sx={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginBottom: '0.2rem',
                        }}
                      >
                        {data.showPacking ? (
                          <Box
                            sx={{
                              textAlign: 'center',
                              direction: 'rtl',
                              fontSize: '2.5mm',
                            }}
                          >
                            {data.package}
                          </Box>
                        ) : null}
                        {data.showDate ? (
                          <Box
                            sx={{
                              textAlign: 'left',
                              direction: 'rtl',
                              fontSize: '8px',
                            }}
                          >
                            تاریخ: {data.date}
                          </Box>
                        ) : (
                          <div />
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            {/* <Box
            sx={{
              '@media print': {
                pageBreakAfter: 'always',
                breakAfter: 'page',
              },
            }}
          /> */}
            <Box
              // ref={printElRef}
              sx={{
                position: 'relative',
                color: 'black',
                fontSize: '0.8rem',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                maxWidth: '50mm',
                maxHeight: '35mm',
                minWidth: '50mm',
                minHeight: '35mm',
                direction: 'ltr',
                border: '1px solid #ccc',
                paddingX: '6px',
                // paddingTop: '2mm',
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: '8px',
                  left: '0',
                }}
              >
                <img
                  src={data.type === '8' ? PrintLogo2 : PrintLogo}
                  width={75}
                  alt=""
                />
              </Box>
              <Box
                sx={{
                  width: '100%',
                  height: '35mm',
                  // paddingTop: '5mm',
                  // paddingBottom: '1mm',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    justifyContent: 'flex-end',
                    height: '100%',
                    gap: '0.2rem',
                  }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      height: '17mm',
                      maxHeight: '17mm',
                      display: 'flex',
                      flexDirection: 'row-reverse',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      gap: '0.2rem',
                      paddingTop: '14px',
                    }}
                  >
                    <Box
                      as="img"
                      src={data.qr}
                      sx={{
                        alignSelft: 'start',
                        height: '16mm',
                        width: '16mm',
                      }}
                    />
                    <Box
                      sx={{
                        width: 'calc(100% - 17.5mm)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        paddingTop: '24px',
                      }}
                    >
                      <Box
                        sx={{
                          width: '100%',
                          display: 'flex',
                          flexDirection: 'column-reverse',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <Box
                          sx={{
                            width: '100%',
                            textAlign: 'left',
                            direction: 'rtl',
                            fontSize: '12px',
                          }}
                        >
                          {data.code2}
                        </Box>
                        <Box
                          sx={{
                            width: '100%',
                            textAlign: 'right',
                            direction: 'rtl',
                            fontSize: '9px',
                          }}
                        >
                          کد فنی:
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignSelf: 'start',
                      justifyContent: 'space-around',
                      // paddingTop: '0.6rem',
                      // minHeight: data.type === '0' ? '25mm' : '32.64mm',
                      flexGrow: '1',
                    }}
                  >
                    <div>
                      <Box
                        sx={{
                          height: '9mm',
                          textAlign: 'center',
                          direction: 'rtl',
                          fontSize: '3mm',
                        }}
                      >
                        <Textfit
                          mode="multi"
                          min={7}
                          max={14}
                          style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            fontWeight: 'bold',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          {data.name}
                        </Textfit>
                      </Box>
                    </div>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        marginTop: '-2px',
                      }}
                    >
                      <Box
                        sx={{
                          textAlign: 'left',
                          direction: 'rtl',
                          fontSize: '9px',
                        }}
                      >
                        {data.code1}
                      </Box>

                      <Box
                        sx={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginBottom: '0.2rem',
                        }}
                      >
                        {data.showPacking ? (
                          <Box
                            sx={{
                              textAlign: 'center',
                              direction: 'rtl',
                              fontSize: '2.5mm',
                            }}
                          >
                            {data.package}
                          </Box>
                        ) : null}
                        {data.showDate ? (
                          <Box
                            sx={{
                              textAlign: 'left',
                              direction: 'rtl',
                              fontSize: '8px',
                            }}
                          >
                            تاریخ: {data.date}
                          </Box>
                        ) : (
                          <div />
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        ) : null}

        {data ? (
          <Box sx={{ display: 'flex', gap: '10px', mt: '1rem' }}>
            <Button
              onClick={reactToPrintFn}
              variant="contained"
              color="primary"
            >
              پرینت
            </Button>
            <Button
              onClick={() => setOpen(false)}
              variant="contained"
              color="warning"
            >
              بستن
            </Button>
          </Box>
        ) : null}
      </Box>
    </Dialog>
  );
}

// // atrass
